/**
 * Snowflake Cascade Animation - WORKING VERSION
 * Simplified SVG approach that actually renders
 */

(function() {
  'use strict';

  // Configuration
  const config = {
    snowflakeCount: 30,
    minSize: 15,
    maxSize: 30,
    minDuration: 4000,
    maxDuration: 8000,
    color: '#ffffff'
  };

  // Simple, reliable SVG snowflake designs
  function getSnowflakeSVG(color) {
    const designs = [
      // Design 1: Classic star
      `<svg width="100%" height="100%" viewBox="0 0 50 50" xmlns="http://www.w3.org/2000/svg">
        <g stroke="${color}" stroke-width="1.5" fill="none" stroke-linecap="round">
          <line x1="25" y1="5" x2="25" y2="45"/>
          <line x1="5" y1="25" x2="45" y2="25"/>
          <line x1="12" y1="12" x2="38" y2="38"/>
          <line x1="38" y1="12" x2="12" y2="38"/>
          <line x1="25" y1="10" x2="20" y2="15"/>
          <line x1="25" y1="10" x2="30" y2="15"/>
          <line x1="25" y1="40" x2="20" y2="35"/>
          <line x1="25" y1="40" x2="30" y2="35"/>
          <line x1="10" y1="25" x2="15" y2="20"/>
          <line x1="10" y1="25" x2="15" y2="30"/>
          <line x1="40" y1="25" x2="35" y2="20"/>
          <line x1="40" y1="25" x2="35" y2="30"/>
        </g>
      </svg>`,
      
      // Design 2: Detailed
      `<svg width="100%" height="100%" viewBox="0 0 50 50" xmlns="http://www.w3.org/2000/svg">
        <g stroke="${color}" stroke-width="1.5" fill="none" stroke-linecap="round">
          <line x1="25" y1="7" x2="25" y2="43"/>
          <line x1="7" y1="25" x2="43" y2="25"/>
          <line x1="13" y1="13" x2="37" y2="37"/>
          <line x1="37" y1="13" x2="13" y2="37"/>
          <line x1="25" y1="12" x2="22" y2="17"/>
          <line x1="25" y1="12" x2="28" y2="17"/>
          <line x1="12" y1="25" x2="17" y2="22"/>
          <line x1="12" y1="25" x2="17" y2="28"/>
          <line x1="38" y1="25" x2="33" y2="22"/>
          <line x1="38" y1="25" x2="33" y2="28"/>
          <line x1="25" y1="38" x2="22" y2="33"/>
          <line x1="25" y1="38" x2="28" y2="33"/>
        </g>
      </svg>`,
      
      // Design 3: Simple elegant
      `<svg width="100%" height="100%" viewBox="0 0 50 50" xmlns="http://www.w3.org/2000/svg">
        <g stroke="${color}" stroke-width="2" fill="none" stroke-linecap="round">
          <line x1="25" y1="10" x2="25" y2="40"/>
          <line x1="10" y1="25" x2="40" y2="25"/>
          <line x1="15" y1="15" x2="35" y2="35"/>
          <line x1="35" y1="15" x2="15" y2="35"/>
          <circle cx="25" cy="25" r="5" stroke-width="1.5"/>
        </g>
      </svg>`,
      
      // Design 4: Crystal
      `<svg width="100%" height="100%" viewBox="0 0 50 50" xmlns="http://www.w3.org/2000/svg">
        <g stroke="${color}" stroke-width="1.5" fill="none" stroke-linecap="round">
          <line x1="25" y1="5" x2="25" y2="45"/>
          <line x1="5" y1="25" x2="45" y2="25"/>
          <line x1="10" y1="10" x2="40" y2="40"/>
          <line x1="40" y1="10" x2="10" y2="40"/>
          <line x1="25" y1="9" x2="21" y2="13"/>
          <line x1="25" y1="9" x2="29" y2="13"/>
          <line x1="25" y1="41" x2="21" y2="37"/>
          <line x1="25" y1="41" x2="29" y2="37"/>
          <line x1="9" y1="25" x2="13" y2="21"/>
          <line x1="9" y1="25" x2="13" y2="29"/>
          <line x1="41" y1="25" x2="37" y2="21"/>
          <line x1="41" y1="25" x2="37" y2="29"/>
        </g>
      </svg>`,
      
      // Design 5: Delicate
      `<svg width="100%" height="100%" viewBox="0 0 50 50" xmlns="http://www.w3.org/2000/svg">
        <g stroke="${color}" stroke-width="1.2" fill="none" stroke-linecap="round">
          <line x1="25" y1="8" x2="25" y2="42"/>
          <line x1="8" y1="25" x2="42" y2="25"/>
          <line x1="12" y1="12" x2="38" y2="38"/>
          <line x1="38" y1="12" x2="12" y2="38"/>
          <polyline points="25,13 22,16 25,19 28,16 25,13"/>
          <polyline points="25,37 22,34 25,31 28,34 25,37"/>
          <polyline points="13,25 16,22 19,25 16,28 13,25"/>
          <polyline points="37,25 34,22 31,25 34,28 37,25"/>
        </g>
      </svg>`
    ];
    
    return designs[Math.floor(Math.random() * designs.length)];
  }

  function createSnowflake() {
    const flake = document.createElement('div');
    flake.className = 'snowflake-cascade';
    
    // Get random properties
    const size = config.minSize + Math.random() * (config.maxSize - config.minSize);
    const startX = Math.random() * 100;
    const endX = startX + (Math.random() - 0.5) * 20;
    const duration = config.minDuration + Math.random() * (config.maxDuration - config.minDuration);
    const delay = Math.random() * 1000;
    const rotation = Math.random() * 360;
    const endRotation = rotation + (Math.random() - 0.5) * 180;
    
    // Set SVG content with embedded color
    flake.innerHTML = getSnowflakeSVG(config.color);
    
    // Apply styles
    flake.style.cssText = `
      position: fixed;
      top: -50px;
      left: ${startX}%;
      width: ${size}px;
      height: ${size}px;
      pointer-events: none;
      z-index: 9999;
      opacity: 0;
      transform: rotate(${rotation}deg);
      will-change: transform, opacity;
    `;
    
    // Create animation
    const animName = `snowfall-${Date.now()}-${Math.random().toString(36).substr(2, 9)}`;
    const keyframes = `
      @keyframes ${animName} {
        0% {
          transform: translateY(0) translateX(0) rotate(${rotation}deg);
          opacity: 0;
        }
        10% {
          opacity: 0.9;
        }
        90% {
          opacity: 0.9;
        }
        100% {
          transform: translateY(${window.innerHeight + 100}px) translateX(${(endX - startX)}vw) rotate(${endRotation}deg);
          opacity: 0;
        }
      }
    `;
    
    // Add keyframes to page
    const style = document.createElement('style');
    style.textContent = keyframes;
    document.head.appendChild(style);
    
    // Apply animation
    flake.style.animation = `${animName} ${duration}ms linear ${delay}ms forwards`;
    
    // Add to page
    document.body.appendChild(flake);
    
    // Cleanup
    setTimeout(() => {
      flake.remove();
      style.remove();
    }, duration + delay + 100);
  }

  function initSnowfallCascade() {
    // Prevent multiple instances
    if (document.querySelector('.snowflake-cascade')) return;
    
    // Create all snowflakes
    for (let i = 0; i < config.snowflakeCount; i++) {
      createSnowflake();
    }
  }

  // Export function
  window.initSnowfallCascade = initSnowfallCascade;
  
  // Auto-start
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSnowfallCascade);
  } else {
    // Small delay to ensure page is ready
    setTimeout(initSnowfallCascade, 100);
  }
})();